<template>
  <div>
    <div  class="d-flex"
          v-if="imageUrl != '' && imageUrl != null"
    >
      <div
        class="w-40px h-40px mr-10px"
        :style="{
                      'background-image': `url(${image})`,
                      'background-size': 'contain',
                    }"
      ></div>
      <div
        class="d-flex align-center w-190px mr-12px"
        :style="{
                      overflow: 'hidden',
                      'text-overflow': 'ellipsis',
                      'white-space': 'nowrap',
                    }"
      >
        {{ imageUrl }}
      </div>
      <button
        class="btn w-88px"
        @click="setUrl('')"
      >
        移除圖片
      </button>
    </div>
    <div class="d-flex" v-else>
      <input type="file" id="file" ref="image_upload" @change="onChange" hidden>
      <button class="btn w-140px mr-5" @click="chooseFiles">上傳圖片</button>
      <button class="btn w-140px mr-10" @click="isGallaryOpen = true">從圖庫選擇圖片</button>
      <MaterialGalleryCreater
        :isOpen="isGallaryOpen"
        @gallary-close="isGallaryOpen = false"
        @setUrl="setUrl"
      ></MaterialGalleryCreater>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MaterialGalleryCreater from '@/components/C-1-1-1__Category-Create_UploadImage-From-MaterialGallery.vue';

export default {
  props: [
    'imageUrl',
    'dir',
  ],
  components: {
    MaterialGalleryCreater,
  },
  data: () => ({
    fileList: [],
    isGallaryOpen: false,
  }),
  computed: {
    image() {
      if (this.imageUrl && this.imageUrl.indexOf('/storage/') === 0) {
        return `${process.env.VUE_APP_HOST}${this.imageUrl}`;
      }

      return this.imageUrl;
    },
  },
  methods: {
    ...mapActions({
      upload: 'upload',
    }),
    ...mapActions('notifications', {
      error: 'error',
    }),
    onChange(e) {
      e.preventDefault();
      const data = e.target.files || e.dataTransfer.files;
      if (!data.length) {
        return;
      }
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].type.indexOf('image') === -1) {
          this.error('支援格式：.png/.jpg/.gif');
          return;
        }
      }
      this.handleFileUpload(data);
    },
    handleFileUpload(data) {
      const formData = new FormData();
      formData.append('dir', this.dir);
      for (let i = 0; i < data.length; i += 1) {
        formData.append('file', data[i], data[i].name);
      }
      this.upload(formData).then((res) => {
        this.setUrl(res.url);
      });
    },
    chooseFiles() {
      this.$refs.image_upload.click();
    },
    setUrl(url) {
      this.$emit('update:imageUrl', url);
    },
  },
};
</script>

<style lang="scss">
.uploadimg {
  width: 280px;

  &-body {
    height: 216px;
    border: 1px dashed #848fa0;
    text-align: center;
    border-radius: 4px;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #848fa0;
    }

    .btn {
      margin-top: 9px;
    }

    div {
      margin-top: 10px;
    }
  }

  &-body-drag {
    height: 216px;
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #194cc3;
    background-color: #e8efff;
    color: #1e50c0;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #1e50c0;
    }

    div {
      margin-top: 10px;
    }
  }

  &-body-fail {
    height: 216px;
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #f90000;
    background-color: #ffe7e7;
    color: #ff0000;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #ff0000;
    }

    div {
      margin-top: 10px;
    }
  }
}
</style>
